import ReactGA from 'react-ga';
ReactGA.initialize(process.env.MIX_GOOGLE_ANALYTICS_TRACKING_CODE)

export default ReactGA
